/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyJobCompanyJobMappingStatus {
    FULL_MATCH = 'fullMatch',
    PARTICIPATION_ONLY = 'participationOnly',
    PRICING_ONLY = 'pricingOnly',
}
